var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemIcon = void 0;
var ListItemIcon_1 = __importDefault(require("./ListItemIcon"));
exports.ListItemIcon = ListItemIcon_1.default;
exports.default = ListItemIcon_1.default;
//# sourceMappingURL=index.js.map